import { Separator, SocialSharingGroup } from '@change/ds-core-ui';

import { CopyLinkVisibleUrlButton } from 'src/app/shared/components/CopyLinkVisibleUrlButton';
import { SocialIconWithSuccessState } from 'src/app/shared/components/SocialIconWithSuccessState';

import { useShareActions } from './hooks/useShareActions';

export const ShareActions = () => {
	const { data } = useShareActions();

	const { first, rest, shareVisualUrl } = data;

	if (rest.length === 0) return null;

	return (
		<>
			{first && <CopyLinkVisibleUrlButton buttonConfig={first} data-qa="psf-share-copy-button" />}

			<Separator orientation="horizontal" className="m-0" />

			{shareVisualUrl && (
				<img src={shareVisualUrl} alt="Share Visual Preview" className="mx-auto my-2 block max-w-61 rounded-lg" />
			)}

			<SocialSharingGroup layout="grid" className="items-start justify-items-center gap-y-8 md:grid-cols-5">
				{rest.filter(Boolean).map((actionItem) => (
					<SocialIconWithSuccessState
						key={actionItem.channel}
						data-qa={`psf-share-${actionItem.channel}-button`}
						buttonConfig={actionItem}
						className="text-center"
					/>
				))}
			</SocialSharingGroup>
		</>
	);
};
